import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

import { numberFormatter } from "utils/numberFormatter";
import CustomDotMenu from "components/atoms/CustomDotMenu";
import CustomButton from "components/atoms/CustomButton";
import CustomRightDrawer from "components/atoms/CustomRightDrawer";
import TransactionHistoryDetails from "pages/accounting/ModalContents/transactionDetails/TransactionHistoryDetails";

const Row = ({ row, idx, toggleModal }) => {
  return (
    <TableRow
      sx={{
        "&:nth-of-type(odd)": {
          backgroundColor: "background.custom",
        },
        "&:last-child td, &:last-child th": { border: 0 },
      }}
    >
      <TableCell component="th" scope="row" align="left" sx={{ width: "70px" }}>
        {idx + 1}
      </TableCell>
      <TableCell align="left" sx={{ color: "primary.darkGrey" }}>
        {row?.patient?.ID}
      </TableCell>
      <TableCell align="left" sx={{ color: "primary.darkGrey" }}>
        {row?.paymentReference}
      </TableCell>
      <TableCell align="left" sx={{ color: "primary.darkGrey" }}>
        {`${row?.patient?.firstName || ""} ${row?.patient?.lastName || ""}`}
      </TableCell>

      <TableCell align="left">{row?.paymentMethod}</TableCell>
      <TableCell align="left">
        <CustomButton
          text="View"
          onClick={toggleModal.bind(null, row)}
          variant="containedBrown"
          sx={{ minWidth: "100px" }}
        />
      </TableCell>
    </TableRow>
  );
};

export default function AccountingTransactionHistoryTable({ data }) {
  const [rowdata, setRowData] = React.useState({});

  const modalRef = React.useRef(null);

  const toggleModal = (row) => {
    setRowData(row);
    modalRef?.current?.handleToggle();
  };
  return (
    <>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 640 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell align="left" sx={{ fontWeight: "bold" }}>
                S/N
              </TableCell>
              <TableCell align="left" sx={{ fontWeight: "bold" }}>
                Patient ID
              </TableCell>
              <TableCell align="left" sx={{ fontWeight: "bold" }}>
                Payment Reference
              </TableCell>
              <TableCell align="left" sx={{ fontWeight: "bold" }}>
                Patient's Name
              </TableCell>

              <TableCell align="left" sx={{ fontWeight: "bold" }}>
                Payment method
              </TableCell>
              <TableCell align="left" sx={{ fontWeight: "bold" }}>
                Action
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.length
              ? data?.map((row, i) => (
                  <Row key={i} row={row} idx={i} toggleModal={toggleModal} />
                ))
              : null}
          </TableBody>
        </Table>
      </TableContainer>
      <CustomRightDrawer
        title="Transaction history"
        ref={modalRef}
        drawerSx={{
          width: {
            xs: "100%",
            sm: "85%",
          },
        }}
        subTitle=""
        boxSx={{
          padding: { xs: 4, sm: "60px" },
          pl: { xs: "40px", sm: "0px!important" },
          pt: { xs: "40px", sm: "15px!important" },
        }}
      >
        <TransactionHistoryDetails
          details={rowdata}
          closeModal={() => modalRef?.current?.handleToggle()}
        />
      </CustomRightDrawer>
    </>
  );
}
